'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Badge } from '@/components/ui/app-badge';
import { CopyableCashtagBadge } from './copyable-cashtag-badge';
interface WinnerStatusBadgesProps {
  ticker: string | null;
}
function toCashtag(ticker: string | null): string | null {
  if (ticker === null || ticker === '') return null;
  return ticker.startsWith('$') ? ticker : `$${ticker}`;
}

/** Winner state and token identifier shared by post-resolution surfaces. */
export function WinnerStatusBadges(t0) {
  const $ = _c(11);
  const {
    ticker
  } = t0;
  const t = useTranslations("market.tokenCta");
  let t1;
  if ($[0] !== ticker) {
    t1 = toCashtag(ticker);
    $[0] = ticker;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cashtag = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("winnerBadge");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Badge variant="secondary" className="bg-feedback-success-surface text-feedback-success-content">{t2}</Badge>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== cashtag) {
    t4 = cashtag !== null ? <CopyableCashtagBadge ticker={cashtag} /> : null;
    $[6] = cashtag;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="flex min-w-0 items-center gap-1.5">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}